/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationStepsAliases {
  AUTOC_LICENSE_UF = 'autoc-license-uf',
  AUTOC_MEDICAL_SPECIALTY = 'autoc-medical-specialty',
  AUTOC_PERSONAL_UF = 'autoc-personal-uf',
  AUTOCOMPLETE_GENDER = 'autocomplete-gender',
  CHECKBOX_AGREE_TERMS = 'checkbox-agree-terms',
  DATE_FIELD_BIRTH = 'date-field-birth',
  FETCH_GENDER = 'fetch-gender',
  FETCH_LICENSE_UF = 'fetch-license-uf',
  FETCH_MEDICAL_SPECIALTY = 'fetch-medical-specialty',
  FETCH_PERSONAL_UF = 'fetch-personal-uf',
  FIELD_ADDRESS = 'field-address',
  FIELD_AGREE_TERMS = 'field-agree-terms',
  FIELD_CITY = 'field-city',
  FIELD_CONFIRM_EMAIL = 'field-confirm-email',
  FIELD_CONFIRM_PASSWORD = 'field-confirm-password',
  FIELD_DATE = 'field-date',
  FIELD_EMAIL = 'field-email',
  FIELD_FULL_NAME = 'field-full-name',
  FIELD_ID_NUMBER = 'field-id-number',
  FIELD_LICENSE_NUMBER = 'field-license-number',
  FIELD_MEDICAL = 'field-medical',
  FIELD_NEIGHBORHOOD = 'field-neighborhood',
  FIELD_NUMBER = 'field-number',
  FIELD_PASSWORD = 'field-password',
  FIELD_PERSONAL_STATE = 'field-personal-state',
  FIELD_PHONE = 'field-phone',
  FIELD_POSTAL = 'field-postal',
  FIELD_STATE = 'field-state',
  FIELD_TAXPAYER = 'field-taxpayer',
  FIELDSET_ACCOUNT_DATA = 'fieldset-account-data',
  FORM_ACCOUNT_INFORMATION = 'form-account-information',
  FORM_ADDRESS = 'form-address',
  FORM_PERSONAL_IDENTIFICATION = 'form-personal-identification',
  FORM_PERSONAL_INFORMATION = 'form-personal-information',
  INPUT_ADDRESS = 'input-address',
  INPUT_CITY = 'input-city',
  INPUT_CONFIRM_EMAIL = 'input-confirm-email',
  INPUT_CONFIRM_PASSWORD = 'input-confirm-password',
  INPUT_EMAIL = 'input-email',
  INPUT_FULL_NAME = 'input-full-name',
  INPUT_ID_NUMBER = 'input-id-number',
  INPUT_LICENSE_NUMBER = 'input-license-number',
  INPUT_NEIGHBORHOOD = 'input-neighborhood',
  INPUT_NUMBER = 'input-number',
  INPUT_PASSWORD = 'input-password',
  INPUT_PHONE = 'input-phone',
  INPUT_POSTAL = 'input-postal',
  INPUT_TAXPAYER = 'input-taxpayer',
  LAYOUT_ROOT = 'layout-root',
  MAPPER_LICENSE_UF = 'mapper-license-uf',
  MAPPER_MEDICAL_SPECIALTY = 'mapper-medical-specialty',
  MAPPER_PERSONAL_UF = 'mapper-personal-uf',
  MAPPER_USER_PERSONAL = 'mapper-user-personal',
  NEW_USER_PERSONAL_INFORMATION = 'new-user-personal-information',
  RECAPTCHA = 'recaptcha',
  RECAPTCHA_FIELD = 'recaptcha-field',
  STEP_ACCOUNT_INFORMATION = 'step-account-information',
  STEP_PERSONAL_ADDRESS = 'step-personal-address',
  STEP_PERSONAL_IDENTIFICATION = 'step-personal-identification',
  STEP_PERSONAL_INFORMATION = 'step-personal-information',
  TEXT_LICENSE_UF = 'text-license-uf',
  TEXT_MEDICAL_SPECIALTY = 'text-medical-specialty',
  TEXT_PERSONAL_UF = 'text-personal-uf',
  TEXT_USER_PERSONAL = 'text-user-personal',
  WIZARD_ACCOUNT_CREATION = 'wizard-account-creation',
}
export { AccountCreationStepsAliases };
